import { ModulesMap } from '@/config/data/modulesMaps.js'
import { STORE_MAP } from './cache-engine'

export const DATA_MAP = {
	LAND_DOCUMENT_TYPES: 'land_document_types',
	WORK_REPORT_DOCUMENTS: 'work_report_documents',
	REGULATIONS_STAGE_TAGS: 'regulation_stage_tags',
	WORKS_PRODUCTIVITY_NORMS: 'works_productivity_norms',
	WORKS_SERVICE_PAYMENT_RATE_NORMS: 'works_service_payment_rates_norms',
	WORKS_MATERIAL_PRODUCTION_RATE_NORMS: 'works_materials_production_norms',
	WORKS_COST_CATEGORIES: 'works_cost_categories',
	REGULATION_TAGS: 'regulation_tags',
	EQUIPMENT_GROUPS: 'equipment_groups',
	STAFF_GROUPS: 'staff_groups',
	STAFF_DEPARTMENTS: 'staff_departments',
	MACHINES: 'machines',
	STAFF: 'staff',
	EQUIPMENT: 'equipment',
	INFRASTRUCTURES: ModulesMap.INFRASTRUCTURES,
	INFRASTRUCTURE_TYPES: 'infrastructure_types',
	LEGAL_ENTITIES: 'legal_entities',
	DEVICES: 'devices',
	SENSORS: 'sensors',
	DEVICE_MOUNTS: 'device_mounts',
	FIELDS: 'fields',
	CLUSTERS: 'field_clusters',
	WEIGHT_STATIONS: ModulesMap.WEIGHT_STATIONS,
	MATERIALS: 'materials',
	INCIDENT_TAGS: 'incident_tags',
	MATERIALS_CATEGORIES: 'materials_categories',
	MATERIALS_TAGS: 'materials_tags',
	INFRASTRUCTURE_TAGS: 'infrastructures_tags',
	FIELDS_TAGS: 'fields_tags',
	IDENTITY_CARDS: 'identity_cards',
	MACHINES_GROUPS: 'machine_groups',
	STAFF_ROLES: 'staff_roles',
	COUNTERPARTIES: 'counterparties',
	COUNTERPARTIES_GROUPS: 'counterparties_groups',
	WORKS: 'works',
	WORKS_CATEGORIES: 'works_categories',
	WORKS_MATERIAL_CONSUMPTION_RATE_NORMS: 'works_materials_consumption_norms',
	WORKS_QUALITY_NORMS: 'works_quality_norms',
	WORKS_STAFF_PAYMENT_RATES_NORMS: 'works_staff_payment_rates_norms',
	CROPS: 'crops',
	WORK_REPORT_MEASURES: 'work_report_measures',
	WORK_REPORT_PHOTOS: 'work_report_photos',
	WORK_REPORT_LINKS: 'work_report_links',
	FINANCE_CATEGORIES: 'finance_categories',
	FINANCE_GROUPS: 'finance_groups',
	FINANCE_TAGS: 'finance_tags',
	NOTIFICATIONS: 'notifications',
	FUEL_STATIONS: 'fuel_stations',
	WORKS_SHIFT: 'works_shifts',
	LOGISTIC_ROUTE_TAGS: 'logistic_tags',
	LANDS: 'lands',
	LAND_ACTIONS: 'land_actions',
	LAND_CATEGORIES: 'land_categories',
	LAND_OWNERSHIP_TYPES: 'land_ownership_types',
	LAND_PURPOSES: 'land_purposes',
	LANDS_CADASTRAL_CASES: 'land_cadastral_cases',
	REGULATIONS: ModulesMap.REGULATIONS,
}

export const DATA_DISTRIBUTION_SCHEMA = {
	[DATA_MAP.LAND_DOCUMENT_TYPES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORK_REPORT_DOCUMENTS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'title'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.INCIDENT_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},

	[DATA_MAP.REGULATIONS_STAGE_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_PRODUCTIVITY_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_SERVICE_PAYMENT_RATE_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},

	[DATA_MAP.WORKS_MATERIAL_PRODUCTION_RATE_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: ['min_value', 'max_value', 'work', 'material'],
		},
	},
	[DATA_MAP.WORKS_COST_CATEGORIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.REGULATION_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.EQUIPMENT_GROUPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.STAFF_DEPARTMENTS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.MACHINES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'brand', 'model', 'registration_number', 'machine_type'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: [
				'contractor',
				'vin_number',
				'inventory_number',
				'inventory_date',
				'inventory_executor',
				'pledges',
				'documents',
				'transfers',
				'photos',
			],
		},
	},
	[DATA_MAP.STAFF]: {
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'icon', 'position'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: ['created_at', 'deleted_at', 'updated_at'],
		},
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.EQUIPMENT]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: ['created_at', 'deleted_at', 'updated_at', 'created_by'],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'brand', 'model', 'official_number', 'aggregate_type'],
		},
	},
	[DATA_MAP.INFRASTRUCTURES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'infrastructure_type'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: ['description', 'created_at', 'deleted_at', 'updated_at'],
		},
	},
	[DATA_MAP.INFRASTRUCTURE_TYPES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'color'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: ['created_at', 'deleted_at', 'updated_at'],
		},
	},
	[DATA_MAP.LEGAL_ENTITIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: [
				'address',
				'created_at',
				'deleted_at',
				'updated_at',
				'created_by',
				'updated_by',
				'deleted_by',
			],
		},
	},
	[DATA_MAP.DEVICES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'key', 'imei'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: [
				'mounts',
				'source_type',
				'is_active',
				'config',
				'sim_card',
				'producer',
				'model',
				'device_protocol',
				'description',
			],
		},
	},
	[DATA_MAP.SENSORS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
	},
	[DATA_MAP.DEVICE_MOUNTS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: [],
		},
	},
	[DATA_MAP.FIELDS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: [
				'field_type',
				'document_area',
				'fact_3d_area',
				'measure_method',
				'soil_type',
				'quality',
			],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'title', 'fact_area'],
		},
	},
	[DATA_MAP.CLUSTERS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: ['deleted_at'],
		},
		[STORE_MAP.BASE]: {
			attrs: [],
		},
	},
	[DATA_MAP.WEIGHT_STATIONS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
	},
	[DATA_MAP.MATERIALS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'measure'],
		},
	},
	[DATA_MAP.MATERIALS_CATEGORIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.MATERIALS_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.INFRASTRUCTURE_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.STAFF_GROUPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.FIELDS_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.IDENTITY_CARDS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'code'],
		},
	},
	[DATA_MAP.STAFF_ROLES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.MACHINES_GROUPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.COUNTERPARTIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'fullname', 'internal_legal_entity'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
			exclude: [
				'icon_file_id',
				'note',
				'email',
				'phone',
				'address',
				'death_day',
				'birth_day',
				'iban',
				'document_info',
				'is_legal',
				'groups',
			],
		},
	},
	[DATA_MAP.COUNTERPARTIES_GROUPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_CATEGORIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_MATERIAL_CONSUMPTION_RATE_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'metric', 'optimal_value', 'koef'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_QUALITY_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_STAFF_PAYMENT_RATES_NORMS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'metric', 'optimal_value', 'koef'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.CROPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			exclude: ['center_gis', 'shape_gis'],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'culture', 'regulation', 'year'],
		},
	},
	[DATA_MAP.WORK_REPORT_MEASURES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'title'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORK_REPORT_PHOTOS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'title'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORK_REPORT_LINKS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'title'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.FINANCE_CATEGORIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.FINANCE_GROUPS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.FINANCE_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id'],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.NOTIFICATIONS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.FUEL_STATIONS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.WORKS_SHIFT]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LOGISTIC_ROUTE_TAGS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LANDS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: [
				'id',
				'name',
				'cadastral_number',
				'fact_area',
				'linked_fields_ids',
				'linked_infrastructure_ids',
			],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.LAND_ACTIONS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LAND_CATEGORIES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LAND_OWNERSHIP_TYPES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LAND_PURPOSES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
	},
	[DATA_MAP.LANDS_CADASTRAL_CASES]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: [],
		},
		[STORE_MAP.EXTENDED]: {
			attrs: [],
		},
	},
	[DATA_MAP.REGULATIONS]: {
		[STORE_MAP.FULL]: {
			attrs: [],
		},
		[STORE_MAP.BASE]: {
			attrs: ['id', 'name', 'regulation_type', 'period', 'has_linked_process'],
		},
	},
}
